import { useEffect, useMemo, useRef } from 'react';
import { useFormField, useFormActions } from '../core';
import { config } from '../config';

export const useRequiredField = (
  fieldId: string,
  requiresEntry: boolean,
  isFieldNA: boolean,
  hasAnyValue: boolean | null,
  index: number,
) => {
  const { setFieldValue } = useFormActions();
  const requiredFieldRef = useRef<boolean | undefined>(undefined);

  const requiredFieldId = useMemo(
    () => `${fieldId}${config.requiredFieldSuffix}`,
    [fieldId],
  );

  const [requiredField] = useFormField(requiredFieldId);

  // Like the server, only the first entry is asked for: a later blank one is an unfinished Add.
  const isRequired = useMemo(
    () => !requiresEntry || hasAnyValue || isFieldNA || index > 0,
    [requiresEntry, hasAnyValue, isFieldNA, index],
  );

  useEffect(() => {
    if (
      requiredFieldRef.current !== isRequired ||
      requiredField.value !== isRequired
    ) {
      requiredFieldRef.current = isRequired;

      setFieldValue(
        `${fieldId}${config.requiredFieldSuffix}`,
        isRequired,
        true,
      );
    }
  }, [setFieldValue, fieldId, isRequired, requiredField]);

  return { requiredFieldId, isRequired };
};
